import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { LocationStore } from '../../stores/LocationStore';

const IPropTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
  ]).isRequired,
};

const DepartmentEnforcer = observer((props) => {
  const departmentsFetched = LocationStore.departments !== null;
  if (!departmentsFetched) {
    return (
      null
    );
  }
  return props.children;
});

DepartmentEnforcer.propTypes = IPropTypes;

const enforceDepartments = Component => (
  props => (
    <DepartmentEnforcer>
      <Component {...props} />
    </DepartmentEnforcer>
  )
);

export { enforceDepartments };



// WEBPACK FOOTER //
// ./src/hocs/enforce-departments/EnforceDepartments.jsx